import { render } from "./InstrucoesCarregamentoPedidoCanceladosLiquidados.vue?vue&type=template&id=1ab4f9f0&scoped=true"
import script from "./InstrucoesCarregamentoPedidoCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./InstrucoesCarregamentoPedidoCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./InstrucoesCarregamentoPedidoCanceladosLiquidados.vue?vue&type=style&index=0&id=1ab4f9f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab4f9f0"]])

export default __exports__